<div class="approval-user-template-form">
  <div class="p-5">
    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <h3 class="mt-4 inline"
          >{{ !approvalUserTemplateId ? 'Create' : 'Update' }} Approval User
          Template</h3
        >
      </div>
      <div class="align-self-center">
        <button
          *ngIf="!isDialog"
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          [routerLink]="['settings/approval-user-template-settings']"
        >
          <lum-ui-icon
            icon="chevron-left-circle"
            [width]="24"
            [height]="24"
            color="#5563d6"
          ></lum-ui-icon>
          Go Back To Approval User Templates
        </button>

        <button
          *ngIf="isDialog"
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          (click)="dialogRef.close()"
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>
    <mat-divider class="my-2"></mat-divider>
  </div>

  <mat-card class="lum-mat-card" *ngIf="!isDialog">
    <mat-card-content>
      <ng-container *ngTemplateOutlet="approvalUserTemplateForm"></ng-container>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="isDialog">
    <ng-container *ngTemplateOutlet="approvalUserTemplateForm"></ng-container>
  </ng-container>
</div>

<ng-template #approvalUserTemplateForm>
  <form [formGroup]="form">
    <div class="p-5">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>Label</label>
            <input
              formControlName="label"
              type="text"
              required="true"
              class="lum-input"
            />
          </div>
          <mat-error *ngIf="form.get('label')?.invalid">
            {{ form.get('label') | validateField }}
          </mat-error>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Approver</label>
            <input
              [disabled]="(userLoading$ | async) || false"
              [value]="inputValue"
              matInput
              class="lum-input"
              (input)="onSearchKeywordChange($event)"
              [matAutocomplete]="auto"
              #autocompleteInput
            />
            <mat-autocomplete
              panelWidth="auto"
              #auto="matAutocomplete"
              (optionSelected)="onSelectOption($event)"
            >
              <ng-container *ngIf="!(userLoading$ | async) || false; else loader">
                <mat-option *ngFor="let user of users" [value]="user">
                  {{ user?.firstName }} {{ user?.lastName }}
                </mat-option>
              </ng-container>
              <ng-template #loader>
                <mat-option>
                  <div class="flex gap-4">
                    <mat-progress-spinner
                      class="progress-spinner mt-3"
                      diameter="24"
                      mode="indeterminate"
                    ></mat-progress-spinner>
                    <small>Loading...</small>
                  </div>
                </mat-option>
              </ng-template>
            </mat-autocomplete>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="selectedUsers.length > 0">
        <div class="col-12">
          <div>
            <table class="lum-table lum-table--classic striped">
              <thead>
                <tr>
                  <th class="w-p90">Approvers</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngFor="let user of selectedUsers; trackBy: trackById"
                >
                  <tr>
                    <td>
                      <input
                        type="text"
                        class="lum-input"
                        readonly="true"
                        [value]="user.firstName + ' ' + user.lastName"
                      />
                    </td>

                    <td class="actions text-right">
                      <button
                        class="lum-button lum-button--small lum-button--secondary w-20"
                        mat-icon-button
                        (click)="removeSelectedUser(user)"
                      >
                        <lum-ui-icon
                          icon="minus-circle"
                          [width]="16"
                          [height]="16"
                          color="#3a47af"
                        ></lum-ui-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <lum-ui-button [loading]="submittingForm" (clickEvent)="onSubmit()">
          Save
          <lum-ui-icon class="ml-2-5" icon="content-save"></lum-ui-icon>
        </lum-ui-button>
      </div>
    </div>
  </form>
</ng-template>
